/**
 * Verdict values returned by the judge for a submission or individual test case.
 */
export const VERDICTS = [
  'pending', // queued, not yet picked up
  'running', // judge is actively executing
  'accepted', // all cases passed
  'wrong_answer', // output didn't match
  'time_limit_exceeded',
  'memory_limit_exceeded',
  'runtime_error', // non-zero exit, unhandled exception, segfault
  'compile_error',
  'output_limit_exceeded', // program wrote too much to stdout
  'internal_error', // judge/container failure (not user's fault)
] as const;

export type Verdict = (typeof VERDICTS)[number];

export const VERDICT_LABELS: Record<Verdict, string> = {
  pending: 'Pending',
  running: 'Running',
  accepted: 'Accepted',
  wrong_answer: 'Wrong Answer',
  time_limit_exceeded: 'Time Limit Exceeded',
  memory_limit_exceeded: 'Memory Limit Exceeded',
  runtime_error: 'Runtime Error',
  compile_error: 'Compile Error',
  output_limit_exceeded: 'Output Limit Exceeded',
  internal_error: 'Internal Error',
};

export function isTerminalVerdict(v: Verdict): boolean {
  return v !== 'pending' && v !== 'running';
}

export function isAccepted(v: Verdict): boolean {
  return v === 'accepted';
}
